import StudentItem from './StudentItem';

export default StudentItem;
